import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  href: string;
  children: React.ReactNode;
}
export function CTAButton({
  href,
  children
}: CTAButtonProps) {
  return <a href={href} className="group inline-flex w-full max-w-[560px] items-center justify-center gap-2 rounded-md border-b-4 border-diagdark bg-diag px-5 py-4 text-center font-display text-[19px] font-bold uppercase leading-tight tracking-wide text-white shadow-[0_10px_26px_-10px_rgba(242,106,15,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-diaghover active:translate-y-[2px] sm:px-10 sm:py-5 sm:text-[24px]" data-id="element-30" data-mp="2kz7npo98lt6q">
      <span data-id="element-31" data-mp="33r0f5e8nr6cc">{children}</span>
      <ChevronRightIcon className="hidden h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" strokeWidth={3} aria-hidden="true" data-id="element-32" data-mp="2ypjffm1wtpxc" />
    </a>;
}